import clientLinks from 'js/components/client-links/index.js'
import template from './index.pug'
import menuI from 'js/pages/municipality/index.js'

export default Vue.extend({
  name: 'transport-conditions-page-custom-cg',
  template: template(),
  components: {clientLinks,menuI},
  computed: {
    content() {
      const msg = this.$i18n.getLocaleMessage(this.$i18n.locale) || {}

      return msg.legalNotice || {}
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
})
